module.exports = __webpack_public_path__ + "img/south-korea.b026a630.png";